export const ACTIONS = {
    GET_MOBILE_OTP: "mv/get_mobile_otp",
    SET_OTP_LOADING: "mv/set_Otp_loading",
    SET_EMAIL_AUTH_LOADING: "mv/set_email_loading",
    SET_PAN_LOADING: "mv/set_pan_loading",
    SET_PAN_LINK_LOADING: "mv/set_pan_link_loading",
    SET_BANK_AUTH_LOADING: "mv/set_bank_loading",
    SET_VALIDATE_OTP_LOADING:"mv/set_validate_otp_loading",
    SET_FACE_MATCHING_LOADING:"mv/set_face_matching_loading",
    SET_OCR_KYC_LOADING:"mv/set_ocr_kyc_loading",
    POST_VALIDATE_OTP_INPUT:"mv/post_validate_otp_input",
    SET_MOBILE_DETAILS_LOADING:"mv/set_mobile_details_loading",
    POST_MOBILE_DETAILS_DATA:"mv/post_mobile_details_data",
    POST_EMAIL_AUTHENTICATION_DATA:"mv/post_email_authentication_data",
    POST_BANK_AUTHENTICATION_DATA:"mv/post_bank_authentication_data",
    POST_PAN_AUTHENTICATION_DATA:"mv/post_pan_authentication_data",
    POST_PAN_LINK_WITH_AADHAAR_AUTHENTICATION_DATA:"mv/post_pan_link_with_aadhaar_authentication_data",
    VALIDATE_FACE_MATCHING:"mv/validate_face_matching",
    VALIDATE_OCR_KYC:"mv/validate_ocr_kyc"
  };
  interface SetLoading {
    type: typeof ACTIONS.SET_OTP_LOADING;
    payload: boolean;
  }
  interface SetMoileDetailsLoading {
    type: typeof ACTIONS.SET_MOBILE_DETAILS_LOADING;
    payload: boolean;
  }
  interface SetEmailLoading {
    type: typeof ACTIONS.SET_EMAIL_AUTH_LOADING;
    payload: boolean;
  }
  interface SetBankLoading {
    type: typeof ACTIONS.SET_BANK_AUTH_LOADING;
    payload: boolean;
  }
  interface SetPanLoading {
    type: typeof ACTIONS.SET_BANK_AUTH_LOADING;
    payload: boolean;
  }
  interface SetPanLinkLoading {
    type: typeof ACTIONS.SET_PAN_LOADING;
    payload: boolean;
  }
  interface SetFaceMathcingLoading {
    type: typeof ACTIONS.SET_FACE_MATCHING_LOADING;
    payload: boolean;
  }
  interface SetOcrKycLoading {
    type: typeof ACTIONS.SET_OCR_KYC_LOADING;
    payload: boolean;
  }
  interface SetValidateOtpInput {
    type: typeof ACTIONS.SET_PAN_LINK_LOADING;
    payload: boolean;
  }
  interface GetMobileOyp {
    type: typeof ACTIONS.GET_MOBILE_OTP;
    payload: Array<any>;
  }
  interface PostValidateOtpInput {
    type: typeof ACTIONS.POST_VALIDATE_OTP_INPUT;
    payload: Array<any>;
  }
  interface PostMobileDetailsData {
    type: typeof ACTIONS.POST_MOBILE_DETAILS_DATA;
    payload: Array<any>;
  }
  interface PostEmailDetailsData {
    type: typeof ACTIONS.POST_EMAIL_AUTHENTICATION_DATA;
    payload: Array<any>;
  }
  interface PostBankDetailsData {
    type: typeof ACTIONS.POST_BANK_AUTHENTICATION_DATA;
    payload: Array<any>;
  }
  interface PostPanDetailsData {
    type: typeof ACTIONS.POST_PAN_AUTHENTICATION_DATA;
    payload: Array<any>;
  }
  interface PostPanLinkWithAadhaarDetailsData {
    type: typeof ACTIONS.POST_PAN_LINK_WITH_AADHAAR_AUTHENTICATION_DATA;
    payload: Array<any>;
  }
  interface ValidateFaceMatching {
    type: typeof ACTIONS.VALIDATE_FACE_MATCHING;
    payload: Array<any>;
  }
  interface ValidateOcrKyc {
    type: typeof ACTIONS.VALIDATE_OCR_KYC;
    payload: Array<any>;
  }
  export type ValidationDashboarType =
  | SetLoading
  | GetMobileOyp
  | SetMoileDetailsLoading
  | SetValidateOtpInput
  | PostValidateOtpInput
  | PostMobileDetailsData
  | PostEmailDetailsData
  | SetEmailLoading
  | PostBankDetailsData
  | SetBankLoading
  | SetPanLoading
  | SetPanLinkLoading
  | PostPanDetailsData
  | PostPanLinkWithAadhaarDetailsData
  | SetFaceMathcingLoading
  | ValidateFaceMatching
  | ValidateOcrKyc
  | SetOcrKycLoading
  